import React from 'react';
import {
  Divider,
  Flex,
  HeroLinearImage,
  InfoCard,
  Loader,
  Text,
} from '@components';
import {
  Container,
  StyledAboutFund,
  StyledInfoCardContainer,
  StyledPortfolioBoxContainer,
  StyledPortfolioPhoto,
  StyledPortfolioPhotoContainer,
} from './ProductOverView.styles';
import { useMediaQueries } from '@utils/mediaQueries/mediaQueries';
import { FormattedMessage } from 'react-intl';
import { Overview } from '@features/api/response/tabContent/Overview';
import { CalculatorCommon } from '@features/api/response/tabContent/Calculator';
import { useTabData } from '@hooks/useTabData';
import { TabType } from '@features/api/response/tabContent/TabType';

const ProductOverView: React.FC = () => {
  const {
    data: productOverview,
    isFetching,
    isLoading,
  } = useTabData<Overview>(TabType.OVERVIEW);
  const { md: isMobile } = useMediaQueries();

  const getTargetReturnValue = (value: any): string => {
    const targetReturn = value as CalculatorCommon;
    return `${targetReturn.fromValue}-${targetReturn.toValue}%`;
  };

  return (
    <Container>
      <Loader isLoading={isFetching || isLoading} />
      {productOverview && (
        <>
          <HeroLinearImage
            data-testid='overview-hero-image'
            image={productOverview.titleImageLink}
            message={productOverview.productName}
          />
          <Flex
            justifyContent='space-between'
            flexDirection={isMobile ? 'column' : 'row'}
          >
            <StyledAboutFund>
              <Text variant='h6' fontWeight='fontWeightBold' color='primary'>
                <FormattedMessage id='product.aboutFund' />
              </Text>
              <Text
                pt={12}
                lineHeight='29px'
                variant='h6'
                fontWeight='fontWeightRegular'
                data-testid='product-detail-description'
              >
                {productOverview.aboutFund}
              </Text>
            </StyledAboutFund>
            <StyledInfoCardContainer>
              {productOverview.properties.map((item) => (
                <InfoCard
                  title={item.name}
                  subtitle={
                    item.name === 'Target Net Return (in USD p.a.)'
                      ? getTargetReturnValue(item.value)
                      : item.value
                  }
                  key={item.name}
                  icon={item.icon}
                />
              ))}
            </StyledInfoCardContainer>
          </Flex>
          <Flex mt={10} flexDirection='column'>
            <Divider />
            <StyledPortfolioBoxContainer>
              <Text variant='h6' fontWeight='fontWeightRegular'>
                <FormattedMessage id='product.portfolioFunds' />
              </Text>
              <StyledPortfolioPhotoContainer>
                {productOverview.subscribedPortfolioFundsImages.map((photo) => (
                  <StyledPortfolioPhoto key={photo} src={photo} />
                ))}
              </StyledPortfolioPhotoContainer>
            </StyledPortfolioBoxContainer>
          </Flex>
        </>
      )}
    </Container>
  );
};

export default ProductOverView;
